import FormValidation from '../../modules/FormValidation';
import Modal from "../../modules/Modal";
export default class ServiceDateRequest {
    constructor(formId = 'service-date-request-form') {
        this.form = document.getElementById(formId);
        this.modalContainer = document.querySelector('[data-modal="service-date-request"]');
        this.errorMessage = this.form.querySelector('.error-message');
        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.ajaxUrl = window.localize_script.admin_ajax;
        // Initialize form validation
        this.formValidation = new FormValidation(this.form, {
            showErrorsOnSubmit: true,
            clearErrorsOnFocus: true,
            generalErrorSelector: '.error-message'
        });
        this.init();
    }
    init() {
        this.modal = new Modal('service-date-request');
        this.modal.onClose(() => {
            this.updateModalState(true);
        });
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.handleSubmit();
        });
    }
    handleSubmit() {
        const formData = new FormData(this.form);
        this.setLoadingState(true);
        fetch(this.ajaxUrl, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => response.json())
            .then(data => {
            var _a;
            if (data.success) {
                this.updateModalState(false);
            }
            else {
                if ((_a = data.data) === null || _a === void 0 ? void 0 : _a.errors) {
                    this.formValidation.showErrors(data);
                }
                else {
                    this.formValidation.showGeneralError(data.data.message ||
                        this.form.getAttribute('data-error-process') ||
                        'An error occurred while processing your order.');
                }
            }
        })
            .catch(error => {
            console.error('Error:', error);
        })
            .finally(() => {
            this.setLoadingState(false);
        });
    }
    updateModalState(reset) {
        const modalHeader = this.modalContainer.querySelector('.modal-window-header');
        const formTitle = this.modalContainer.querySelector('.service-date-request-title');
        const successMessage = this.modalContainer.querySelector('.success-message');
        if (reset) {
            this.form.reset();
            modalHeader.classList.remove('hidden');
            formTitle === null || formTitle === void 0 ? void 0 : formTitle.classList.remove('hidden');
            this.form.classList.remove('hidden');
            successMessage.classList.add('hidden');
        }
        else {
            modalHeader.classList.add('hidden');
            formTitle === null || formTitle === void 0 ? void 0 : formTitle.classList.add('hidden');
            this.form.classList.add('hidden');
            successMessage.classList.remove('hidden');
        }
    }
    setLoadingState(loading) {
        if (loading) {
            this.submitButton.disabled = true;
        }
        else {
            this.submitButton.disabled = false;
        }
    }
}
